module.exports = "/_next/static/images/15a94b3137c8d0d4df4820641a8ee043-man-looking-at-phone@xs-1x.jpg.webp";